import React from 'react';
import Progress from './Progress';

/**
 * Compact character count + Progress meter for form fields.
 */
export default function CharacterMeter({ current, max, barClassName = 'bg-gradient-insight' }) {
  return (
    <div className="flex items-center justify-between mt-2">
      <p className="text-sm text-critic-text-muted font-normal">
        {current.toLocaleString()}/{max.toLocaleString()} characters
      </p>
      <Progress
        value={(current / max) * 100}
        className="w-24 h-1"
        trackClassName="bg-white/[0.1]"
        barClassName={barClassName}
        aria-label="Character count"
      />
    </div>
  );
}
